module.exports = __webpack_public_path__ + "static/media/arrow-right.1de8c6ce.svg";